import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import {
    MDBBtn, MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody,
    MDBCardImage, MDBInput, MDBIcon, MDBCheckbox
} from 'mdb-react-ui-kit';
import './Register.css';
import { Button } from "@mui/material";
var config = require("../../src/config/dev").default;

const Register = (props) => {
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [firstname, setfirstName] = useState('');
    const [lastname, setlastName] = useState('');
    const [password, setPass] = useState('');
    const [confirmpass, setconfirmPass] = useState('');
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [isFormValid, setIsFormValid] = useState(false);

    const handleConfirmpass = async (e) => {
        console.log("in confirmpass function");
        setconfirmPass(e.target.value);
        if (password !== confirmpass) setError("Password does not match");
    };

    const handleFirstNameChange = (e) => {
        setfirstName(e.target.value);
        setFirstNameError('');
    };

    const handleLastNameChange = (e) => {
        setlastName(e.target.value);
        setLastNameError('');
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError('');
    };

    const handlePhoneChange = (e) => {
        setPhone(e.target.value);
        setPhoneError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(email);

        setFirstNameError('');
        setLastNameError('');
        setEmailError('');
        setPhoneError('');

        if (firstname.trim() === '') {
            setFirstNameError('First Name is required');
            document.getElementById('firstname').classList.add('empty-input');
        }
        if (lastname.trim() === '') {
            setLastNameError('Last Name is required');
            document.getElementById('lastname').classList.add('empty-input');
        }
        if (email.trim() === '') {
            setEmailError('Email is required');
            document.getElementById('email').classList.add('empty-input');
        }
        if (!/^[7-9][0-9]{9}$/.test(phone)) {
            setPhoneError('Please provide a valid phone number');
            document.getElementById('phone').classList.add('empty-input');
        }

        if (firstNameError || lastNameError || emailError || phoneError) {
            document.getElementById("confirmspin").style.display = "none";
            return;
        }

        document.getElementById("confirmspin").style.display = "block";

        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const user = {
            affiliateId: "",
            isStatus: false,
            departmentId: "65013ed3cf81351bd8ef6f35",
            organizationId: "65013ed3cf81351bd8ef6f35",
            role: "manager",
            entity: "organization",
            firstName: firstname,
            lastName: lastname,
            roleName: "Marketplace User",
            email: email,
            phoneNumber: phone,
            timeZone: timeZone,
            createdBy: { firstName: firstname, lastName: lastname, email: email },
            updatedBy: { firstName: firstname, lastName: lastname, email: email }
        };
        console.log(user);

        try {
            await axios.post(config.API_ENDPOINT + "api/v1/user/createMarketPlaceUser", user)
                .then((response) => {
                    console.log(response.status);
                    console.log(response.data);
                    setError(response.data.error);
                    if (!response.data.error) {
                        toast.success("User Registered Successfully!!", {
                            position: 'top-center', autoClose: 3000,
                            onClose: () => { window.location.href = "/emailVerification/" + response.data.data._id; },
                            toastClassName: 'Toastify__toast-body',
                        });
                    } else {
                        toast.error("Something Went Wrong!!", {
                            position: 'top-center', autoClose: 3000,
                            onClose: () => { window.location.reload(); },
                            toastClassName: 'Toastify__toast-body',
                        });
                    }
                });
        } catch (error) {
            console.error("Error:", error);
        } finally {
            document.getElementById("confirmspin").style.display = "none";
        }
    };

    return (
        <div className="rp-page">

            {/* ══ LEFT panel ══ */}
            <div className="rp-left">

                <div className="rp-left-brand">
                    <span className="rp-left-icon">&#128279;</span>
                    <div>
                        <div className="rp-left-title">TraceChain</div>
                        <div className="rp-left-subtitle">NFT Marketplace</div>
                    </div>
                </div>

                <img
                    src={require("../images/login_nft.png")}
                    className="rp-left-img"
                    alt="TraceChain NFT"
                />

                <p className="rp-left-tagline">
                    Join thousands of users trading<br />verified digital asset tokens
                </p>

                <div className="rp-info-cards">
                    <div className="rp-info-card">
                        <div className="rp-info-icon">&#127881;</div>
                        <div>
                            <div className="rp-info-title">Free to Join</div>
                            <div className="rp-info-desc">Create your account in seconds, no fees</div>
                        </div>
                    </div>
                    <div className="rp-info-card">
                        <div className="rp-info-icon">&#128200;</div>
                        <div>
                            <div className="rp-info-title">Trade NFT Tokens</div>
                            <div className="rp-info-desc">Buy &amp; sell verified digital asset tokens</div>
                        </div>
                    </div>
                    <div className="rp-info-card">
                        <div className="rp-info-icon">&#128274;</div>
                        <div>
                            <div className="rp-info-title">Secure &amp; Verified</div>
                            <div className="rp-info-desc">Every transaction is blockchain-secured</div>
                        </div>
                    </div>
                </div>

            </div>

            {/* ══ RIGHT panel — registration form ══ */}
            <div className="rp-right">
                <div className="rp-card">

                    <div className="rp-card-accent"></div>

                    <div className="rp-card-body">
                        <h2 className="rp-form-title">Create Account</h2>
                        <p className="rp-form-sub">Sign up to start trading NFT tokens</p>

                        <form onSubmit={handleSubmit} className="rp-form">

                            <div className="rp-row-fields">
                                <div className="rp-field">
                                    <label className="rp-label" htmlFor="firstname">First Name</label>
                                    <MDBInput
                                        value={firstname}
                                        onChange={handleFirstNameChange}
                                        type="text"
                                        placeholder="First name"
                                        id="firstname"
                                        name="firstname"
                                        size="lg"
                                        title="Name should be in a Text Format Only"
                                        style={{ fontSize: '13px' }}
                                    />
                                    {firstNameError && <div className="rp-error">{firstNameError}</div>}
                                </div>
                                <div className="rp-field">
                                    <label className="rp-label" htmlFor="lastname">Last Name</label>
                                    <MDBInput
                                        value={lastname}
                                        onChange={handleLastNameChange}
                                        type="text"
                                        placeholder="Last name"
                                        id="lastname"
                                        name="lastname"
                                        size="lg"
                                        title="Name should be in a Text Format Only"
                                        style={{ fontSize: '13px' }}
                                    />
                                    {lastNameError && <div className="rp-error">{lastNameError}</div>}
                                </div>
                            </div>

                            <div className="rp-field">
                                <label className="rp-label" htmlFor="email">Email Address</label>
                                <MDBInput
                                    value={email}
                                    onChange={handleEmailChange}
                                    type="email"
                                    placeholder="you@example.com"
                                    id="email"
                                    name="email"
                                    size="lg"
                                    style={{ fontSize: '13px' }}
                                />
                                {emailError && <div className="rp-error">{emailError}</div>}
                            </div>

                            <div className="rp-field">
                                <label className="rp-label" htmlFor="phone">Phone Number</label>
                                <MDBInput
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    type="tel"
                                    placeholder="10-digit mobile number"
                                    id="phone"
                                    name="phone"
                                    size="lg"
                                    pattern="[7-9]{1}[0-9]{9}"
                                    title="Please provide valid phone number"
                                    style={{ fontSize: '13px' }}
                                />
                                {phoneError && <div className="rp-error">{phoneError}</div>}
                            </div>

                            <div className="rp-check-row">
                                <MDBCheckbox label='I agree to the Terms &amp; Conditions' />
                            </div>

                            <button type="submit" className="rp-submit-btn">CREATE ACCOUNT</button>

                        </form>

                        <div id="confirmspin" className="rp-loader" style={{ display: "none" }}>Loading...</div>
                        <ToastContainer />

                        <p className="rp-login-link">
                            Already have an account?&nbsp;<Link to="/login">Log In</Link>
                        </p>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default Register;
